import "./style.css";

import React from "react";

import AudioActionButtons from "./AudioActionButtons";
import AudioPlaybackRate from "./AudioPlaybackRate";
import AudioTimeDisplay from "./AudioTimeDisplay";
import AudioTimeSlider from "./AudioTimeSlider";
import AudioVolumeSlider from "./AudioVolumeSlider";

interface IAudioControlsProps {
  isPlaying: boolean;
  isMuted: boolean;
  volume: number;
  playbackRate: number;
  currentTime: number;
  duration: number;
  onPlayPause: () => void;
  onSeek: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onVolumeChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onMuteUnmute: () => void;
  onPlaybackRateChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  formatTime: (time: number) => string;
}

const AudioControls: React.FC<IAudioControlsProps> = ({
  isPlaying,
  isMuted,
  volume,
  playbackRate,
  currentTime,
  duration,
  onPlayPause,
  onSeek,
  onVolumeChange,
  onMuteUnmute,
  onPlaybackRateChange,
  formatTime,
}) => (
  <div className="audio-controls">
    <AudioTimeSlider
      currentTime={currentTime}
      duration={duration}
      onSeek={onSeek}
    />
    <div className="audio-controls-wrapper">
      <div className="audio-action-wrapper">
        <AudioActionButtons
          isPlaying={isPlaying}
          isMuted={isMuted}
          onPlayPause={onPlayPause}
          onMuteUnmute={onMuteUnmute}
        />
        <AudioVolumeSlider volume={volume} onVolumeChange={onVolumeChange} />
        <AudioTimeDisplay
          currentTime={currentTime}
          duration={duration}
          formatTime={formatTime}
        />
      </div>

      <AudioPlaybackRate
        playbackRate={playbackRate}
        onPlaybackRateChange={onPlaybackRateChange}
      />
    </div>
  </div>
);

export default AudioControls;
